import { IconButton } from 'components/elements';
import { StyledButton } from 'components/elements/Button/Button.styled';
import { StyledIcon } from 'components/elements/Icon/Icon.styled';
import { StyledScrollArea } from 'components/elements/ScrollArea/ScrollArea.styled';
import { styled } from 'styles';

export const SidePanelActions = styled.div`
  display: grid;
  grid-area: actions;
  grid-gap: ${({ theme }) => theme.spacing.absolute.smaller};
  padding: ${({ theme }) => theme.spacing.absolute.larger};

  ${StyledButton} {
    width: 100%;
  }
`;

export const SidePanelBody = styled.div`
  display: grid;
  flex: 1;
  grid-area: body;
  grid-template-areas:
    'children'
    'actions';
  grid-template-columns: 100%;
  grid-template-rows: 1fr auto;
`;

export const SidePanelCloseButton = styled(IconButton).attrs({
  icon: 'close',
})`
  background-color: transparent;
  border-radius: 50%;
  font-size: 1.5em;
  height: 1.4em;
  width: 1.4em;

  ${StyledIcon} {
    font-size: 1em;
  }
`;

export const SidePanelDrawer = styled.div`
  background-color: ${({ theme }) => theme.card.background};
  box-shadow: ${({ theme }) => theme.shadow.huge};
  display: grid;
  grid-template-areas:
    'header'
    'body';
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr;
  max-width: 28rem;
  transform: translateX(100%);
  transition: transform ${({ theme }) => theme.transition.medium} ease-in-out;
  width: 100%;

  @media (max-width: 768px) {
    max-width: unset;
  }

  ${StyledScrollArea} {
    height: 100%;
  }
`;

export const SidePanelHeader = styled.div`
  align-items: center;
  display: flex;
  grid-area: header;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.absolute.larger};
`;

export const SidePanelTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  user-select: none;
`;

export const StyledSidePanel = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  height: 100%;
  justify-content: flex-end;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: opacity ${({ theme }) => theme.transition.medium} ease-in-out;
  width: 100%;
  z-index: 10;

  &.enter {
    opacity: 0;

    ${SidePanelDrawer} {
      transform: translateX(100%);
    }
  }

  &.enter-active,
  &.enter-done {
    opacity: 1;

    ${SidePanelDrawer} {
      transform: translateX(0);
    }
  }

  &.exit {
    opacity: 1;

    ${SidePanelDrawer} {
      transform: translateX(0);
    }
  }

  &.exit-active {
    opacity: 0;

    ${SidePanelDrawer} {
      transform: translateX(100%);
    }
  }
`;

SidePanelActions.displayName = 'SidePanelActions';
SidePanelBody.displayName = 'SidePanelBody';
SidePanelCloseButton.displayName = 'SidePanelCloseButton';
SidePanelDrawer.displayName = 'SidePanelDrawer';
SidePanelHeader.displayName = 'SidePanelHeader';
StyledSidePanel.displayName = 'SidePanel.Styled';
